<template>
  <v-container fluid>
    <v-layout text-xs-left wrap>
    <div v-if="authenticated">
      <v-flex xs4>
        <v-img
          :src="require('../assets/logo-soma-square.svg')"
          class="my-3"
          contain
          height="200"
        ></v-img>
      </v-flex>
      <v-flex xs12>
        <h1 class="display-2 font-weight-bold mb-3">
          Re:Monitor
        </h1>
        <div class="font-weight-regular text-md-left">
          <span class="headline font-weight-bold mb-3">Remote monitoring of your kilns:</span>
          <br><v-icon color="green darken-2">check_circle_outline</v-icon> Rule-based notifications of temperature events
          <br><v-icon color="green darken-2">check_circle_outline</v-icon> Rule-based alerts for temperature rate anomalies
          <br><v-icon color="green darken-2">check_circle_outline</v-icon> Display temperature graphs
          <br><v-icon color="green darken-2">check_circle_outline</v-icon> Display and report historical data
        </div>
      </v-flex>
      <v-flex xs12>
      <br/>
      <p>&copy; Soma Pottery 2019</p>
      </v-flex>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

  export default {
    data() {
        return {}
    },
    computed: {
        ...mapState([
            'authenticated'
        ])
    }
  }
</script>

<style>
</style>